import React from "react";
import { useLocation } from "react-router-dom";
import "../../assets/css/Header/Header.css";
import Logo from "../../assets/images/logo.webp";
import NotificationBell from "../Common/NotificationBell";

const Header = ({ toggleSidebar, isSidebarOpen }) => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;

    if (path.includes("/organization")) return "Organizations";
    if (path.includes("/contact")) return "Contacts";
    if (path.includes("/deals")) return "Deals";
    if (path.includes("/tasks") || path.includes("/my-tasks")) return "My Tasks";

    return "CRM";
  };

  return (
    <header className="top-header">
      {/* LEFT */}
      <div className="header-left">
        <button
          className="menu-btn"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? "Close Menu" : "Open Menu"}
        >
          {isSidebarOpen ? "✕" : "☰"}
        </button>

        <div className="logo-container">
          <img src={Logo} alt="CRM Logo" className="header-logo" />
        </div>
      </div>

      {/* CENTER */}
      <div className="header-center">
        <h2 className="page-title">{getPageTitle()}</h2>
      </div>

      {/* RIGHT */}
      <div className="header-right">
        <NotificationBell />
        <div className="user-box">
          <div className="avatar"></div>
          <span className="user-name">Chetanya Kumar</span>
        </div>
      </div>
    </header>
  );
};

export default Header;